var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{attrs:{"size":"small"}},[_c('div',{staticClass:"col-span-full flex flex-col gap-y-4"},[(_vm.headline)?_c('BaseHeadline',{staticClass:"text-center",attrs:{"text":_vm.headline}}):_vm._e(),_vm._v(" "),_c('SocialMediaButtons',{attrs:{"id":_vm.anchorName,"buttons":_vm.buttons}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }